const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  button: {
    backgroundColor: theme.palette.accent
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/settings/styles.js